import { Dimensions, Platform } from 'react-native';
import { Button as ButtonPaper, Colors, FAB } from 'react-native-paper';
import styled, { css } from 'styled-components/native';

import Button, { Props as ButtonProps } from '@src/components/Button';
import Image from '@src/components/Image';
import ImageBackground from '@src/components/ImageBackground';
import {
  Body1,
  Body2,
  H1,
  H2,
  H3,
  Subtitle2,
} from '@src/components/Typography';
import { padding, windowWidth } from '@src/configuration/constants';

const height = 300;

export const Title = styled(H1)`
  font-weight: 700;
`;

export const TinyText = styled(Subtitle2)<{ textColor?: string }>`
  color: ${({ theme, textColor }) =>
    textColor ? textColor : theme.colors.onBackground};
`;

export const NormalText = styled(Body2)<{
  textColor?: string;
  marginSize?: number;
}>`
  color: ${({ theme, textColor }) =>
    textColor ? textColor : theme.colors.onAccent};
  margin-left: ${({ marginSize }) => (marginSize ? marginSize : 0)}px;
`;
export const BoldText = styled(H2)<{ textColor?: string }>`
  font-weight: 700;
  color: ${({ theme, textColor }) =>
    textColor ? textColor : theme.colors.onAccent};
`;

export const LargeText = styled(H2)<{ textColor?: string }>`
  margin-start: 7px;
  color: ${({ theme, textColor }) =>
    textColor ? textColor : theme.colors.onAccent};
`;

export const DialogBody = styled(Body1)`
  margin-top: 10px;
`;

export const FabViewz = styled.Button`
  font-size: 32px;
  color: white;
`;
export const FabView = styled.Button.attrs({
  size: 'large',
  Type: 'flat',
})`
  width: 48px;
  height: 48px;
  position: absolute;
  bottom: 68px;
  right: ${windowWidth - 56}px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.onAccent};
  shadow-offset: {width: 0, height:0};
  shadow-opacity: 0;
  shadow-radius: 0;
`;
export const SupportButton = styled(FAB).attrs({
  size: 'large',
  Type: 'flat',
})`
  width: 48px;
  height: 48px;
  position: absolute;
  bottom: 68px;
  right: ${windowWidth - 56}px;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15);
  background-color: ${({ theme }) => theme.colors.background};
  shadow-offset: {width: 0, height:0};
  shadow-opacity: 0;
  shadow-radius: 0;
`;
export const RowPrice = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 10px;
  ${Platform.select({
    ios: css`
      padding-bottom: 20px;
    `,
    web: css`
      padding-bottom: 10px;
    `,
  })};

  height: 64px;
`;

export const Cover = styled(Image)`
  width: ${windowWidth}px;
  height: ${height}px;
`;

export const Content = styled.View`
  padding: ${padding / 2}px ${padding}px ${padding / 2}px ${padding}px;
`;

export const ContentImage = styled.View`
  border-radius: ${({ theme }) => theme.roundness}px;
  background-color: ${({ theme }) => theme.colors.placeholder};
  overflow: hidden;
  margin-right: 16px;
  margin-left: 16px;
  margin-top: 10px;
`;
export const CoverTour = styled(ImageBackground).attrs({
  resizeMode: 'cover',
})`
  width: 100%;
  height: ${windowWidth * 0.75}px;
`;

export const Avatar = styled(Image).attrs({
  resizeMode: 'cover',
})`
  border-radius: 11px;
  width: 22px;
  height: 22px;
`;

export const Row = styled.View`
  flex-direction: row;
  margin-top: 10px;
  margin-left: 4px;
  align-items: center;
`;

export const Column = styled.View`
  padding: 0px;
  padding-bottom: 5px;
`;

export const Icon = styled(Image)`
  width: 24px;
  height: 24px;
  resize-mode: contain;
  margin-left: -6px;
`;
export const BuyView = styled.View`
  height: 40px;
`;
export const Buy = styled(Button).attrs<ButtonProps>(
  ({ theme, mode, preset }) => ({
    preset: preset ?? 'primary',
    mode: mode ?? 'contained',
    uppercase: false,
    style: {
      alignItems: 'center',
    },
    contentStyle: {
      backgroundColor: '#ff00ff',
      borderRadius: 8,
    },
  })
)`
  margin-bottom: 0px;
  padding: 0px 14px 0px 14px;
  justify-content: center;
  height: 47px;
`;

export const DiscountCode = styled(ButtonPaper).attrs(({ theme }) => ({
  mode: 'outline',
  color: theme.colors.primary,
  style: {
    color: theme.colors.primary,
    borderWidth: 1,
    borderRadius: 12,
    borderColor: '#ff00dd',
    height: 52,
  },
  labelStyle: {
    color: theme.colors.onAccent,
  },
  uppercase: false,
}))`
  margin-bottom: 10px;
  margin-top: 20px;
  border-color: '#ff00dd';
`;

export const ActionButton = styled(Button).attrs<ButtonProps>(
  ({ mode, preset }) => ({
    mode: mode ?? 'text',
    preset: preset ?? 'primary',
  })
)`
  margin-horizontal: 5px;
`;

export const DatesContainer = styled.View`
  flex-direction: row;
  justify-content: space-around;
  background-color: #efefef;
`;

export const SpacedRow = styled.View`
  flex-direction: row;
  margin-bottom: 7px;
  justify-content: space-between;
  align-items: center;
`;

export const RateRow = styled.View`
  justify-content: center;
  padding: 0 ${padding}px;
`;

export const Price = styled(H1)`
  color: ${({ theme }) => theme.colors.onPrimary};
`;

const size = 22;

export const Bullet = styled.View`
  background-color: black;
  width: ${size}px;
  height: ${size}px;
  border-radius: ${size / 2}px;
  margin-left: 1px;
`;
export const LeaderButton = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border-color: ${({ theme }) => theme.colors.additional};
  padding: ${padding / 3}px;
  padding: ${padding / 3}px;
  border-width: 1px;
`;
